import { FC } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { ApiKeyRoleType } from '../types/api-key-types';
import { apiKeyTypeMap } from '../utils/api-key-utils';
import { Typography } from '@mui/material';

const ApiKeyTypeRadioButton: FC<
  React.PropsWithChildren<ApiKeyTypeRadioButtonProps>
> = ({ apiKeyRoleTypes, apiKeyType, setApiKeyType }) => {
  const handleSetApiKeyType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setApiKeyType((event.target as HTMLInputElement).value as ApiKeyRoleType);
  };

  return (
    <div>
      <Typography color='text.primary'>API Key Type</Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby='api-key-type-radio-buttons-group-label'
          defaultValue={ApiKeyRoleType.CICDIntegration}
          name='api-key-type-radio-buttons-group'
          value={apiKeyType}
          onChange={handleSetApiKeyType}>
          {apiKeyRoleTypes.map(apiKeyType => (
            <FormControlLabel
              key={apiKeyType}
              value={apiKeyType}
              control={<Radio />}
              label={apiKeyTypeMap[apiKeyType]}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export interface ApiKeyTypeRadioButtonProps {
  apiKeyRoleTypes: ApiKeyRoleType[];
  apiKeyType: ApiKeyRoleType;
  setApiKeyType: React.Dispatch<React.SetStateAction<ApiKeyRoleType>>;
}

export default ApiKeyTypeRadioButton;
